import { useMemo } from 'react';
import { Table } from 'antd';
import { withContainer } from '../HOC';

const ScrollTable = (props) => {
  const { containerWidth, fixHeight, rowKey = 'id', rowClassName = (record, index) => null, ...other } = props;

  const scrollConfig = useMemo(() => {
    if (!containerWidth || !props.columns.length) return null;
    const totalWidth = props.columns.reduce((prev, current) => {
      return prev + (current.width || 150);
    }, 0);
    const scrollConfig = {};
    if (fixHeight) scrollConfig.y = fixHeight;
    if (totalWidth > containerWidth) scrollConfig.x = totalWidth;
    return scrollConfig;
  }, [containerWidth, props.columns, fixHeight]);

  if (!props.columns.length) return null;

  return <Table {...other} rowKey={rowKey} scroll={scrollConfig} rowClassName={rowClassName} />;
};

export default withContainer(ScrollTable);
